<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.or_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="or_custname">
            <label class="weui-form-preview__label">{{
              customLabel.or_custname || "客户名称"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.or_custname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="or_date">
            <label class="weui-form-preview__label">{{
              customLabel.or_date || "发票日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.main.or_date, 'yyyy-MM-dd')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_currency">
            <label class="weui-form-preview__label">{{
              customLabel.or_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">
              {{ form.main.or_currency }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="or_amount">
            <label class="weui-form-preview__label">{{
              customLabel.or_amount || "应收金额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.or_amount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_payamount">
            <label class="weui-form-preview__label">{{
              customLabel.or_payamount || "已收金额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.or_payamount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_refno">
            <label class="weui-form-preview__label">{{
              customLabel.or_refno || "税票号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.or_refno
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_taxamount">
            <label class="weui-form-preview__label">{{
              customLabel.or_taxamount || "税额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.or_taxamount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_catename">
            <label class="weui-form-preview__label">{{
              customLabel.or_catename || "科目"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.or_catename }}
            </span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pp_text1 || '自定义字段1'"
          v-model="form.main.pp_text1" slot="pp_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text2 || '自定义字段2'"
          v-model="form.main.pp_text2" slot="pp_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text3 || '自定义字段3'"
          v-model="form.main.pp_text3" slot="pp_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text4 || '自定义字段4'"
          v-model="form.main.pp_text4" slot="pp_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text5 || '自定义字段5'"
          v-model="form.main.pp_text5" slot="pp_text5" hidden="true" />
        </custom-layout>
      </div>

      

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.os_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.os_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="or_auditdate">
            <label class="weui-form-preview__label">{{
              customLabel.or_auditdate || "审核日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.main.or_auditdate, 'yyyy-MM-dd')
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.or_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.or_remark
            }}</span>
          </div>
        </div>
      </div>
      <file-list v-model="form.main.or_attach" />
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import form from "@/mixins/form.js";
import CustomField from "@/components/field/CustomField.vue";
// import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    FileList,
    CustomField
    // CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/money/otherbillar",
      caller: "OtherBillAr",
      xtype: "money-otherbillar-formpanel"
    };
  }
};
</script>